import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
`;

export const Wrapper = styled.div`
  text-align: center;
  padding: 40px 0;
`;

export const Icon = styled.img`
  width: 24px;
  margin-bottom: 16px;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black6};
`;
